import React, { useEffect } from 'react'

import { connect, useDispatch } from 'react-redux'
import { get, isEmpty } from 'lodash'
import { GET_PACKAGE, GET_MY_RECORDS_USAGE, GET_CLOUD_RECORDS } from '../../redux/actions/type'

import { Views } from '../../views'

const MyRecord = ({ keycloak, language }) => {
    const dispatch = useDispatch()
    const { MyRecord } = Views

    useEffect(() => {
        if (!isEmpty(keycloak) && !keycloak.authenticated) {
            window.location.href = '/portal'
        }
    }, [keycloak])

    useEffect(() => {
        dispatch({
            type: GET_PACKAGE
        })
        dispatch({
            type: GET_MY_RECORDS_USAGE
        })
        dispatch({
            type: GET_CLOUD_RECORDS,
            page: 1,
            perPage: 10,
            sortBy: 'create_date:desc',
            startDate: '',
            endDate: ''
        })
        return () => {}
    }, [dispatch, keycloak])

    return (
        !isEmpty(keycloak) && keycloak.authenticated ? (
            <MyRecord keycloak={keycloak} language={language} />
        ) : null
    )
}

const mapStateToProps = state => ({
    keycloak: get(state, "keycloak", ""),
    language: get(state, 'language', 'th')
})

export default connect(mapStateToProps, {})(MyRecord)
